import React from "react";
import Button from "../../../shared/Button";
import swal from "sweetalert";
import Select from "../../../shared/Select";

const AssessmentConfigurationModal = ({
  assessments,
  aggregationWeightConfiguration,
  setAggregationWeightConfiguration,
  closeModal,
}) => {
  const handleChange = (e, index) => {
    const newData = aggregationWeightConfiguration?.map((item, i) =>
      index === i ? { ...item, weight: e.target.value } : item,
    );

    let sum = 0;
    const totalWeight = newData?.reduce((acc, item) => {
      sum += Number(item.weight);
    }, sum);

    if (sum > 100) {
      swal("Oops", "Total weight cannot be greater than 100");
      return;
    }

    setAggregationWeightConfiguration(newData);
  };

  const handleRemoveRow = (index) => {
    setAggregationWeightConfiguration((prev) => {
      const updated = prev?.filter((_, idx) => idx !== index);
      return updated;
    });
  };

  const handleAddRow = () => {
    setAggregationWeightConfiguration((prev) => [
      ...prev,
      { assessment: null, weight: "" },
    ]);
  };

  const validateAssessmentWeights = () => {
    const invalid = aggregationWeightConfiguration?.some(
      (input) => input?.assessment && (!input.weight || input.weight === ""),
    );

    if (invalid) {
      swal("Oops", "Please enter weight for all selected assessments.");
      return true;
    }

    return false;
  };

  return (
    <>
      <div className="arr-table-container">
        <table className="arr-table">
          <thead>
            <tr>
              <th>
                <span className="required">Assessment</span>
              </th>
              <th>
                <span className="required">Weight</span>
              </th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {aggregationWeightConfiguration?.length > 0 ? (
              aggregationWeightConfiguration?.map((item, index) => (
                <tr
                  key={`assessment-${index}`}
                  style={{ alignItems: "center", gap: "8px" }}
                >
                  <td width={400}>
                    <Select
                      value={
                        assessments?.find((o) => o.value === item.assessment) ||
                        null
                      }
                      options={assessments?.filter(
                        (opt) =>
                          !aggregationWeightConfiguration?.some(
                            (agg, i) =>
                              i !== index && agg?.assessment === opt?.value,
                          ),
                      )}
                      onChange={(option) => {
                        const newData = aggregationWeightConfiguration?.map(
                          (item, i) =>
                            index === i
                              ? { ...item, assessment: option?.value }
                              : item,
                        );

                        setAggregationWeightConfiguration(newData);
                      }}
                    />
                  </td>

                  <td>
                    <input
                      className="form-control"
                      type="number"
                      min={0}
                      value={aggregationWeightConfiguration[index].weight}
                      placeholder="Weight(%)"
                      onKeyDown={(e) => {
                        if (e.key === "-" || e.key === "e") e.preventDefault();
                      }}
                      onChange={(e) => handleChange(e, index)}
                    />
                  </td>

                  <td>
                    <Button
                      variant="danger"
                      size="sm"
                      onClick={() => handleRemoveRow(index)}
                    >
                      Remove
                    </Button>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td style={{ textAlign: "center" }} colSpan={3}>
                  No Aggregation Configuration Found
                </td>
              </tr>
            )}
          </tbody>
        </table>
        <div className="action-btns end" style={{ marginTop: "24px" }}>
          <Button size="sm" onClick={handleAddRow}>
            Add Row
          </Button>
        </div>
      </div>

      <div className="arr-note">
        <strong>Note: </strong>The remaining percentage (if total weight is less
        than 100%) will be automatically contributed by the currently active
        assessment.
      </div>

      <div style={{ marginTop: "24px" }} className="action-btns end">
        <Button
          size="sm"
          variant="outline"
          onClick={() => {
            setAggregationWeightConfiguration([
              { assessment: null, weight: "" },
            ]);
            closeModal();
          }}
        >
          Cancel
        </Button>
        <Button
          size="sm"
          onClick={() => {
            if (validateAssessmentWeights()) {
              return;
            }
            closeModal();
          }}
        >
          Done
        </Button>
      </div>
    </>
  );
};

export default AssessmentConfigurationModal;
